(function () {
    'use strict';

    function workflowSummaryController($scope, $rootScope, $window, $uibModal, $timeout,
        notifyService, workflowStateService, sessionData, milestones, milestoneModalService) {

        var vm = this;
        vm.workflowData = workflowStateService.get();
        vm.workflowId = vm.workflowData.Id.split('/')[1];
        vm.accessingEntityId = sessionData.EntityId;
        vm.adminMode = sessionData.IsAdminEntity;

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        vm.hasAdminStatuses = vm.workflowData.AdminAttributes.some(function (attribute) {
            return attribute.$type === 'Ecap.Api.ViewModels.StatusSearchFieldViewModel, Ecap.Api';
        });

        vm.attributeOptions = {
            hasStatuses : vm.workflowData.Attributes.some(function(attribute) {
                return attribute.$type === 'Ecap.Api.ViewModels.StatusSearchFieldViewModel, Ecap.Api';
            }),
            hasAttributes : vm.workflowData.Attributes.some(function(attribute) {
                return attribute.$type !== 'Ecap.Api.ViewModels.StatusSearchFieldViewModel, Ecap.Api';
            }),
            hasAdminStatuses : vm.workflowData.AdminAttributes.some(function(attribute) {
                return attribute.$type === 'Ecap.Api.ViewModels.StatusSearchFieldViewModel, Ecap.Api';
            }),
            hasAdminAttributes : vm.workflowData.AdminAttributes.some(function(attribute) {
                return attribute.$type !== 'Ecap.Api.ViewModels.StatusSearchFieldViewModel, Ecap.Api';
            })
        }

        vm.workflowData.Attributes.forEach(function (attribute) {
            attribute.Mode = 'Editor';
        });

        vm.workflowData.AdminAttributes.forEach(function (attribute) {
            attribute.Mode = vm.adminMode ? 'Editor' : 'Display';
        });

        vm.updateField = function (fieldName) {
            workflowStateService.update(vm.workflowData);
            notifyService.notify('You updated ' + fieldName + ' for the project');
        };

        vm.redirectToEntityViewer = function () {
            $timeout(function() {
                $window.location = '/crm/accounts/details/' + vm.workflowData.Entity.Id.toLowerCase();
            }, 2000);
        }

        vm.entityActions = sessionData.IsAdminEntity ?
        {
            view: {
                label: "View Profile",
                call: vm.redirectToEntityViewer
            }
        }
        : null;

        vm.openDeleteAlert = function (state) {
            var modalInstance = $uibModal.open({
                templateUrl: 'deleteWorkflowModal',
                controller: 'deleteWorkflowModalController',
                resolve: {
                    workflowId: function() {
                        return vm.workflowData.Id;
                    }
                }
            });

            return modalInstance.result.then(function(wasDeleted) {
                if (wasDeleted) {
                    $window.location = '/dashboard';
                }
            });
        }
    }

    workflowSummaryController.$inject = ['$scope', '$rootScope', '$window', '$uibModal', '$timeout',
        'notifyService', 'workflowStateService', 'sessionData', 'milestones', 'milestoneModalService'];

angular.module('ecap.workflow').controller('workflowSummaryController', workflowSummaryController);
})();
